"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { useMemo, useState } from "react";
import { evidenceTopicData, evidenceTopics, type EvidenceTopicData, type EvidenceTopicSlug } from "../evidence-data";
const sources = ["전체", "네이버", "구글", "카카오", "모두닥"] as const;
const gradeBackgrounds = {
  S: "linear-gradient(135deg, var(--gradient-sky-from), var(--gradient-sky-to))",
  A: "linear-gradient(135deg, var(--gradient-coral-from), var(--gradient-coral-to))",
  B: "linear-gradient(135deg, var(--gradient-indigo-from), var(--gradient-indigo-to))",
  D: "radial-gradient(circle at 28% 17%, var(--gradient-mint-from), var(--gradient-mint-to))",
  F: "linear-gradient(135deg, var(--gradient-amber-from), var(--gradient-amber-to))"
} as const;
const sourceMarkerBackgrounds: Record<string, string> = {
  N: gradeBackgrounds.D,
  G: gradeBackgrounds.S,
  K: gradeBackgrounds.A,
  M: gradeBackgrounds.B,
  Y: gradeBackgrounds.F
};
interface EvidenceExplorerProps {
  data: EvidenceTopicData;
  displayCount: number;
}
export function EvidenceExplorer(t0) {
  const $ = _c(115);
  const {
    data,
    displayCount
  } = t0;
  const [selectedTopic, setSelectedTopic] = useState(data.slug);
  const [selectedSource, setSelectedSource] = useState("\uC804\uCCB4");
  const [sortDirection, setSortDirection] = useState("latest");
  const [visibleCount, setVisibleCount] = useState(4);
  let t1;
  if ($[0] !== selectedSource || $[1] !== selectedTopic || $[2] !== sortDirection) {
    const topicReviews = selectedTopic === "all" ? evidenceTopics.flatMap(_temp) : evidenceTopicData[selectedTopic].reviews;
    const filtered = selectedSource === "\uC804\uCCB4" ? topicReviews : topicReviews.filter(review => review.source === selectedSource);
    let t2;
    if ($[4] !== sortDirection) {
      t2 = (a, b) => sortDirection === "latest" ? b.date.localeCompare(a.date) : a.date.localeCompare(b.date);
      $[4] = sortDirection;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = [...filtered].sort(t2);
    $[0] = selectedSource;
    $[1] = selectedTopic;
    $[2] = sortDirection;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const reviews = t1;
  const topicCount = selectedTopic === "all" ? evidenceTopicData.reviews.count : selectedTopic === data.slug ? displayCount : evidenceTopicData[selectedTopic].count;
  let t2;
  if ($[6] !== selectedTopic) {
    t2 = selectedTopic === "all" ? evidenceTopics.reduce(_temp2, 0) : evidenceTopicData[selectedTopic].reviews.length;
    $[6] = selectedTopic;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const topicReviewCount = t2;
  const topicLabel = selectedTopic === "all" ? "\uC804\uCCB4" : evidenceTopicData[selectedTopic].label;
  let t3;
  if ($[8] !== reviews.length || $[9] !== selectedSource || $[10] !== topicCount || $[11] !== topicReviewCount) {
    t3 = selectedSource === "\uC804\uCCB4" ? topicCount : Math.max(reviews.length, Math.round(topicCount * reviews.length / topicReviewCount));
    $[8] = reviews.length;
    $[9] = selectedSource;
    $[10] = topicCount;
    $[11] = topicReviewCount;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const filteredCount = t3;
  const headerTopic = selectedTopic === "all" ? null : evidenceTopicData[selectedTopic];
  let t10;
  let t11;
  let t12;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  let visibleReviews;
  if ($[13] !== filteredCount || $[14] !== headerTopic || $[15] !== reviews || $[16] !== selectedSource || $[17] !== selectedTopic || $[18] !== sortDirection || $[19] !== topicCount || $[20] !== topicLabel || $[21] !== visibleCount) {
    visibleReviews = reviews.slice(0, visibleCount);
    let t13;
    let t14;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Link href="/ulthera/v1/effect" className="hover:text-ink-2">울쎄라</Link>;
      t14 = <span aria-hidden="true">›</span>;
      $[32] = t13;
      $[33] = t14;
    } else {
      t13 = $[32];
      t14 = $[33];
    }
    let t15;
    if ($[34] !== headerTopic) {
      t15 = headerTopic ? <Link href={`/ulthera/v1/${headerTopic.slug}`} className="hover:text-ink-2">{headerTopic.label}</Link> : <span className="text-ink-3">전체</span>;
      $[34] = headerTopic;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    let t16;
    let t17;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <span aria-hidden="true">›</span>;
      t17 = <span className="font-bold text-ink-2">근거 후기</span>;
      $[36] = t16;
      $[37] = t17;
    } else {
      t16 = $[36];
      t17 = $[37];
    }
    let t18;
    if ($[38] !== t15) {
      t18 = <nav className="flex items-center gap-[7px] text-[12px] font-medium text-ink-4" aria-label={"\uD604\uC7AC \uC704\uCE58"}>{t13}{t14}{t15}{t16}{t17}</nav>;
      $[38] = t15;
      $[39] = t18;
    } else {
      t18 = $[39];
    }
    const t19 = selectedTopic === "all" ? "\uC6B8\uC384\uB77C \uAE00 \uC804\uCCB4\uC758 \uADFC\uAC70\uAC00 \uB41C" : "\uC774 \uAE00\uC758 \uADFC\uAC70\uAC00 \uB41C";
    let t20;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <br />;
      $[40] = t20;
    } else {
      t20 = $[40];
    }
    let t21;
    if ($[41] !== t19 || $[42] !== topicCount) {
      t21 = <h1 className="text-[26px] font-bold leading-[1.4] tracking-[-0.7px] text-ink-1 md:text-[38px]" aria-live="polite">{t19}{t20}후기 {topicCount}개</h1>;
      $[41] = t19;
      $[42] = topicCount;
      $[43] = t21;
    } else {
      t21 = $[43];
    }
    let t22;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <p className="max-w-[560px] text-[14px] leading-[1.7] tracking-[-0.3px] text-ink-3 md:text-[14.5px]">본문에 쓴 문장이 어느 후기에서 나왔는지 하나씩 볼 수 있어요.</p>;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    if ($[45] !== t18 || $[46] !== t21) {
      t12 = <section className="flex flex-col gap-[16px] bg-surface-base px-[16px] pb-[28px] pt-[26px] md:px-[32px] md:pb-[42px] md:pt-[38px]">{t18}{t21}{t22}</section>;
      $[45] = t18;
      $[46] = t21;
      $[47] = t12;
    } else {
      t12 = $[47];
    }
    t10 = "md:grid md:grid-cols-[320px_minmax(0,1fr)] md:items-start md:gap-[40px] md:px-[32px] md:pb-[48px] md:pt-[32px]";
    let t23;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <FilterLabel>어느 문장의 근거인지</FilterLabel>;
      $[48] = t23;
    } else {
      t23 = $[48];
    }
    const t24 = selectedTopic === "all";
    let t25;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = () => {
        setSelectedTopic("all");
        setSelectedSource("\uC804\uCCB4");
        setVisibleCount(4);
      };
      $[49] = t25;
    } else {
      t25 = $[49];
    }
    let t26;
    if ($[50] !== t24) {
      t26 = <TopicFilterButton active={t24} onClick={t25}>전체</TopicFilterButton>;
      $[50] = t24;
      $[51] = t26;
    } else {
      t26 = $[51];
    }
    let t27;
    if ($[52] !== selectedTopic) {
      t27 = evidenceTopics.map(topic_1 => {
        const item = evidenceTopicData[topic_1];
        const active = topic_1 === selectedTopic;
        return <TopicFilterButton key={topic_1} active={active} onClick={() => {
          setSelectedTopic(topic_1);
          setSelectedSource("\uC804\uCCB4");
          setVisibleCount(4);
        }}>{item.label}</TopicFilterButton>;
      });
      $[52] = selectedTopic;
      $[53] = t27;
    } else {
      t27 = $[53];
    }
    let t28;
    if ($[54] !== t26 || $[55] !== t27) {
      t28 = <div className="flex flex-col items-start gap-[9px]">{t23}<div className="flex flex-wrap gap-[6px]">{t26}{t27}</div></div>;
      $[54] = t26;
      $[55] = t27;
      $[56] = t28;
    } else {
      t28 = $[56];
    }
    let t29;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
      t29 = <FilterLabel>출처</FilterLabel>;
      $[57] = t29;
    } else {
      t29 = $[57];
    }
    let t30;
    if ($[58] !== selectedSource) {
      t30 = sources.map(source => {
        const active_0 = source === selectedSource;
        return <button key={source} type="button" onClick={() => {
          setSelectedSource(source);
          setVisibleCount(4);
        }} aria-pressed={active_0} className={`flex h-[36px] items-center justify-center rounded-full border px-[13px] text-[12.5px] leading-none tracking-[-0.1px] transition-colors ${active_0 ? "border-line-paper bg-surface-paper font-bold text-ink-paper-1" : "border-line-paper bg-surface-base font-medium text-ink-2 hover:text-ink-1"}`}>{source}</button>;
      });
      $[58] = selectedSource;
      $[59] = t30;
    } else {
      t30 = $[59];
    }
    let t31;
    if ($[60] !== t30) {
      t31 = <div className="flex flex-col items-start gap-[9px]">{t29}<div className="flex flex-wrap gap-[6px]">{t30}</div></div>;
      $[60] = t30;
      $[61] = t31;
    } else {
      t31 = $[61];
    }
    if ($[62] !== t28 || $[63] !== t31) {
      t11 = <aside className="flex flex-col gap-[16px] bg-surface-base px-[16px] pb-[20px] pt-[22px] md:sticky md:top-[72px] md:rounded-[18px] md:border md:border-line-2 md:px-[20px]" aria-label={"\uADFC\uAC70 \uD6C4\uAE30 \uD544\uD130"}>{t28}{t31}</aside>;
      $[62] = t28;
      $[63] = t31;
      $[64] = t11;
    } else {
      t11 = $[64];
    }
    t9 = "min-w-0";
    t6 = "flex flex-col gap-[10px] bg-surface-base px-[16px] pb-[24px] pt-[22px] md:px-0 md:pt-0";
    t7 = "evidence-result-title";
    let t32;
    if ($[65] !== filteredCount || $[66] !== selectedTopic || $[67] !== topicLabel) {
      t32 = <h2 id="evidence-result-title" className="text-[13px] font-bold leading-[1.4] tracking-[-0.2px] text-ink-2">{selectedTopic === "all" ? <>{filteredCount}개 전부 보는 중</> : <>{topicLabel} <span className="text-ink-1">{filteredCount}개</span> 보는 중</>}</h2>;
      $[65] = filteredCount;
      $[66] = selectedTopic;
      $[67] = topicLabel;
      $[68] = t32;
    } else {
      t32 = $[68];
    }
    let t33;
    if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
      t33 = () => setSortDirection(_temp3);
      $[69] = t33;
    } else {
      t33 = $[69];
    }
    const t34 = `현재 ${sortDirection === "latest" ? "\uCD5C\uC2E0\uC21C" : "\uC624\uB798\uB41C\uC21C"}, 정렬 순서 바꾸기`;
    const t35 = sortDirection === "latest" ? "\uCD5C\uC2E0\uC21C" : "\uC624\uB798\uB41C\uC21C";
    let t36;
    if ($[70] !== t34 || $[71] !== t35) {
      t36 = <button type="button" onClick={t33} className="shrink-0 rounded-full border border-line-paper py-[7px] pl-[12px] pr-[10px] text-[12px] font-medium leading-none tracking-[-0.1px] text-ink-2 hover:text-ink-1" aria-label={t34}>{t35} ▾</button>;
      $[70] = t34;
      $[71] = t35;
      $[72] = t36;
    } else {
      t36 = $[72];
    }
    if ($[73] !== t32 || $[74] !== t36) {
      t8 = <div className="flex items-center justify-between gap-[16px] pt-[4px]">{t32}{t36}</div>;
      $[73] = t32;
      $[74] = t36;
      $[75] = t8;
    } else {
      t8 = $[75];
    }
    t4 = "flex flex-col gap-[10px]";
    t5 = visibleReviews.map(_temp5);
    $[13] = filteredCount;
    $[14] = headerTopic;
    $[15] = reviews;
    $[16] = selectedSource;
    $[17] = selectedTopic;
    $[18] = sortDirection;
    $[19] = topicCount;
    $[20] = topicLabel;
    $[21] = visibleCount;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = visibleReviews;
  } else {
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
    visibleReviews = $[31];
  }
  let t13;
  if ($[76] !== t4 || $[77] !== t5) {
    t13 = <div className={t4}>{t5}</div>;
    $[76] = t4;
    $[77] = t5;
    $[78] = t13;
  } else {
    t13 = $[78];
  }
  let t14;
  if ($[79] !== filteredCount || $[80] !== reviews.length || $[81] !== visibleReviews) {
    t14 = reviews.length === 0 ? <p className="rounded-[16px] border border-line-2 px-[16px] py-[36px] text-center text-[13px] text-ink-3">이 출처의 샘플 후기는 아직 없어요.</p> : <button type="button" onClick={() => setVisibleCount(count => Math.min(count + 4, reviews.length))} className="flex w-full items-center justify-center rounded-full border border-line-3 py-[14px] text-[14px] font-bold leading-none tracking-[-0.1px] text-ink-2">{Math.max(0, filteredCount - visibleReviews.length)}개 더 보기</button>;
    $[79] = filteredCount;
    $[80] = reviews.length;
    $[81] = visibleReviews;
    $[82] = t14;
  } else {
    t14 = $[82];
  }
  let t15;
  if ($[83] !== t13 || $[84] !== t14 || $[85] !== t6 || $[86] !== t7 || $[87] !== t8) {
    t15 = <section className={t6} aria-labelledby={t7}>{t8}{t13}{t14}</section>;
    $[83] = t13;
    $[84] = t14;
    $[85] = t6;
    $[86] = t7;
    $[87] = t8;
    $[88] = t15;
  } else {
    t15 = $[88];
  }
  let t16;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <EvidenceRules />;
    $[89] = t16;
  } else {
    t16 = $[89];
  }
  let t17;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p className="text-[11.5px] font-bold leading-none tracking-[0.4px] text-grade-s">원문은 여기까지</p>;
    $[90] = t17;
  } else {
    t17 = $[90];
  }
  let t18;
  if ($[91] !== data.articleTitle) {
    t18 = <h2 className="text-[17px] font-bold leading-[1.5] tracking-[-0.4px] text-ink-1">{data.articleTitle}</h2>;
    $[91] = data.articleTitle;
    $[92] = t18;
  } else {
    t18 = $[92];
  }
  let t19;
  if ($[93] !== data.returnDescription) {
    t19 = <p className="text-[13.5px] leading-[1.7] tracking-[-0.25px] text-ink-3">{data.returnDescription}</p>;
    $[93] = data.returnDescription;
    $[94] = t19;
  } else {
    t19 = $[94];
  }
  const t20 = `/ulthera/v1/${data.slug}`;
  let t21;
  if ($[95] !== t20) {
    t21 = <Link href={t20} className="inline-flex items-center rounded-full bg-surface-paper py-[10px] pl-[14px] pr-[12px] text-[12.5px] font-bold leading-none tracking-[-0.1px] text-ink-paper-1">글로 돌아가기 →</Link>;
    $[95] = t20;
    $[96] = t21;
  } else {
    t21 = $[96];
  }
  let t22;
  if ($[97] !== t18 || $[98] !== t19 || $[99] !== t21) {
    t22 = <div className="flex flex-col items-start gap-[13px] rounded-[14px] bg-gradient-to-b from-[#0d0d0d] to-[#171717] px-[16px] pb-[14px] pt-[15px]" data-node-id="4068:5610">{t17}{t18}{t19}{t21}</div>;
    $[97] = t18;
    $[98] = t19;
    $[99] = t21;
    $[100] = t22;
  } else {
    t22 = $[100];
  }
  let t23;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Link href="/" className="flex w-full items-center justify-center rounded-full border border-line-3 py-[14px] text-[14px] font-bold leading-none tracking-[-0.1px] text-ink-2">메인 홈 가기</Link>;
    $[101] = t23;
  } else {
    t23 = $[101];
  }
  let t24;
  if ($[102] !== t22) {
    t24 = <section className="flex flex-col gap-[12px] bg-surface-base px-[16px] py-[26px] md:bg-surface-3 md:px-[24px] md:py-[40px]">{t22}{t23}</section>;
    $[102] = t22;
    $[103] = t24;
  } else {
    t24 = $[103];
  }
  let t25;
  if ($[104] !== t15 || $[105] !== t24 || $[106] !== t9) {
    t25 = <div className={t9}>{t15}{t16}{t24}</div>;
    $[104] = t15;
    $[105] = t24;
    $[106] = t9;
    $[107] = t25;
  } else {
    t25 = $[107];
  }
  let t26;
  if ($[108] !== t10 || $[109] !== t11 || $[110] !== t25) {
    t26 = <div className={t10}>{t11}{t25}</div>;
    $[108] = t10;
    $[109] = t11;
    $[110] = t25;
    $[111] = t26;
  } else {
    t26 = $[111];
  }
  let t27;
  if ($[112] !== t12 || $[113] !== t26) {
    t27 = <>{t12}{t26}</>;
    $[112] = t12;
    $[113] = t26;
    $[114] = t27;
  } else {
    t27 = $[114];
  }
  return t27;
}
function _temp5(review_0) {
  const badgeLabel = review_0.marker ?? review_0.grade ?? review_0.source.slice(0, 1);
  const badgeBackground = review_0.marker ? sourceMarkerBackgrounds[review_0.marker] ?? gradeBackgrounds.S : review_0.grade ? gradeBackgrounds[review_0.grade] : gradeBackgrounds.S;
  return <article key={review_0.sourceId ?? `${review_0.source}-${review_0.date}-${review_0.text}`} id={review_0.sourceId ? `evidence-${review_0.sourceId}` : undefined} className="flex scroll-mt-[72px] flex-col gap-[13px] rounded-[14px] bg-gradient-to-b from-[#0d0d0d] to-[#171717] px-[16px] pb-[14px] pt-[15px]"><div className="flex items-center gap-[7px]"><span className="flex size-[20px] items-center justify-center rounded-full text-[9.5px] font-bold text-ink-on-accent" style={{
        backgroundImage: badgeBackground
      }} aria-label={review_0.marker ? `${review_0.source} 출처` : `${review_0.grade} 등급`}>{badgeLabel}</span><p className="text-[12.5px] font-bold leading-[1.4] tracking-[-0.2px] text-ink-2">{review_0.source}</p><span className="text-[11px] text-ink-4" aria-hidden="true">·</span><time className="text-[11.5px] text-ink-4" dateTime={review_0.date.replaceAll(".", "-")}>{review_0.date}</time></div><p className="text-[15px] leading-[1.75] tracking-[-0.3px] text-ink-2">{review_0.text}</p><div className="flex flex-wrap gap-[6px]">{review_0.tags.map(_temp4)}</div></article>;
}
function _temp4(tag) {
  return <span key={tag} className="rounded-[6px] bg-surface-4 px-[8px] py-[5px] text-[10.5px] font-medium leading-none tracking-[0.2px] text-ink-tag">{tag}</span>;
}
function _temp3(current) {
  return current === "latest" ? "oldest" : "latest";
}
function _temp2(total, topic_0) {
  return total + evidenceTopicData[topic_0].reviews.length;
}
function _temp(topic) {
  return evidenceTopicData[topic].reviews;
}
function FilterLabel(t0) {
  const $ = _c(3);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `text-[11.5px] font-bold leading-none tracking-[0.3px] text-ink-paper-3 ${className}`;
  let t3;
  if ($[0] !== children || $[1] !== t2) {
    t3 = <p className={t2}>{children}</p>;
    $[0] = children;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
function TopicFilterButton(t0) {
  const $ = _c(5);
  const {
    active,
    children,
    onClick
  } = t0;
  const t1 = `flex h-[36px] items-center justify-center rounded-full border px-[13px] text-[12.5px] leading-none tracking-[-0.1px] transition-colors ${active ? "border-line-paper bg-surface-paper font-bold text-ink-paper-1" : "border-line-paper bg-surface-base font-medium text-ink-2 hover:text-ink-1"}`;
  let t2;
  if ($[0] !== active || $[1] !== children || $[2] !== onClick || $[3] !== t1) {
    t2 = <button type="button" onClick={onClick} aria-pressed={active} className={t1}>{children}</button>;
    $[0] = active;
    $[1] = children;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function EvidenceRules() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [["\uBC18\uBCF5\uB41C \uB9D0\uBD80\uD130", "\uC5EC\uB7EC \uD6C4\uAE30\uC5D0\uC11C \uBC18\uBCF5\uB41C \uB9D0\uC744 \uBA3C\uC800 \uBCF4\uACE0, \uD55C \uC0AC\uB78C\uC758 \uACBD\uD5D8\uC740 \uC804\uCCB4 \uACB0\uACFC\uCC98\uB7FC \uB9D0\uD558\uC9C0 \uC54A\uC558\uC5B4\uC694."], ["\uBCD1\uC6D0 \uAE00\uC740 \uC81C\uC678", "\uBCD1\uC6D0\uC774 \uC9C1\uC811 \uC62C\uB9B0 \uD6C4\uAE30\uB294 \uC218\uC9D1 \uB2E8\uACC4\uC5D0\uC11C \uBE90\uC5B4\uC694."], ["\uBCC4\uC810\uC740 \uC548 \uBD24\uC5B4\uC694", "\uC810\uC218\uAC00 \uC544\uB2C8\uB77C \uBB38\uC7A5\uC5D0 \uBB50\uB77C\uACE0 \uC37C\uB294\uC9C0\uB9CC \uBD24\uC5B4\uC694."], ["\uC774\uB984\uB9CC \uAC00\uB838\uC5B4\uC694", "\uD6C4\uAE30 \uBB38\uC7A5\uC740 \uACE0\uCE58\uAC70\uB098 \uC790\uB974\uC9C0 \uC54A\uACE0, \uBCD1\uC6D0\uACFC \uC758\uB8CC\uC9C4 \uC774\uB984\uB9CC \u25CB\u25CB\uB85C \uBE44\uC2DD\uBCC4 \uCC98\uB9AC\uD588\uC5B4\uC694."]];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const rules = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 id="evidence-rules-title" className="text-[15px] font-bold leading-[1.45] tracking-[-0.3px] text-ink-1">이 글을 쓴 기준</h2>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="bg-surface-base px-[16px] py-[24px] md:px-0 md:py-[32px]" aria-labelledby="evidence-rules-title">{t1}<div className="mt-[14px] flex flex-col gap-[12px]">{rules.map(_temp6)}</div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp6(t0) {
  const [title, description] = t0;
  return <div key={title} className="flex items-start gap-[11px]"><Image src="/figma/evidence/rule-mark.svg" alt="" width={5} height={13} className="h-[13px] w-[5px] shrink-0" /><div><h3 className="text-[14px] font-bold leading-[1.45] tracking-[-0.25px] text-ink-2">{title}</h3><p className="mt-[4px] text-[13px] leading-[1.62] tracking-[-0.2px] text-ink-3">{description}</p></div></div>;
}